import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';
import { getFormattedValueByType } from '~/Utils';

const Table = ({ data }) => {
  const total = data && data.length > 0 ? data.reduce((result, item) => ({
    impressions: result.impressions + item.impressions,
    start: result.start + item.start,
    firstQuartile: result.firstQuartile + item.firstQuartile,
    midpoint: result.midpoint + item.midpoint,
    thirdQuartile: result.thirdQuartile + item.thirdQuartile,
    complete: result.complete + item.complete,
    vtrPercent: 0,
  }), {
    impressions: 0,
    start: 0,
    firstQuartile: 0,
    midpoint: 0,
    thirdQuartile: 0,
    complete: 0,
    vtrPercent: 0,
  }) : null;
  return (
    <Container>
      <thead>
        <tr className="table-header">
          <th>Data</th>
          <th>Impressão</th>
          <th>Play</th>
          <th>1º Quartil</th>
          <th>2º Quartil</th>
          <th>3º Quartil</th>
          <th>Completo</th>
          <th>VTR</th>
        </tr>
      </thead>
      <tbody>
        {data.map(d => (
          <tr key={d.date} className="table-body">
            <td>{d.date}</td>
            <td>{getFormattedValueByType('decimal', d.impressions)}</td>
            <td>{getFormattedValueByType('decimal', d.start)}</td>
            <td>{getFormattedValueByType('decimal', d.firstQuartile)}</td>
            <td>{getFormattedValueByType('decimal', d.midpoint)}</td>
            <td>{getFormattedValueByType('decimal', d.thirdQuartile)}</td>
            <td>{getFormattedValueByType('decimal', d.complete)}</td>
            <td>{`${d.vtrPercent}%`}</td>
          </tr>
        ))}
        {total && (
          <tr className="table-body total">
            <td>TOTAL</td>
            <td>{getFormattedValueByType('decimal', total.impressions)}</td>
            <td>{getFormattedValueByType('decimal', total.start)}</td>
            <td>{getFormattedValueByType('decimal', total.firstQuartile)}</td>
            <td>{getFormattedValueByType('decimal', total.midpoint)}</td>
            <td>{getFormattedValueByType('decimal', total.thirdQuartile)}</td>
            <td>{getFormattedValueByType('decimal', total.complete)}</td>
            <td>-</td>
          </tr>
        )}
      </tbody>
    </Container>
  );
};

Table.defaultProps = {
  data: [],
};

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()),
};

export default Table;
